import React from 'react';
import styled from 'styled-components';

interface StyledCardProps {
    color: string;
    bg: string;
}

const CardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    padding: 5px;
    margin: 5px;
`;

const StyledCard = styled.div<StyledCardProps>`
    background-color: ${({ bg }) => bg};
    color: white;
    padding: 5px 10px;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    max-width: 100%;

    h1 {
        font-size: 18px;
        margin-bottom: 6px;
    }

    p {
        font-size: 14px;
        margin-bottom: 10px;
    }

    img {
        width: 100%;
        border-radius: 8px;
    }
`;

const PrizeCards: React.FC = () => {
    return (
        <CardContainer>
            <StyledCard color="#FFFFFF" bg="#00C000">
                <h1>Early 5</h1>
                <p>Be the first to mark any 5 numbers on your ticket.</p>
                <img
                    draggable={false}
                    src="https://cdn.timepass.games/images/c8cfc6ad-213d-4ebb-9dfe-1bf41cdf5572.png"
                />
            </StyledCard>

            <StyledCard color="#6347BF" bg="#26126A">
                <h1>Corners</h1>
                <p>Mark all four corners of your ticket to win.</p>
                <img
                    draggable={false}
                    src="https://cdn.timepass.games/images/56cef00b-93ef-45ac-99ca-4c53f4f48147.png"
                />
            </StyledCard>

            <StyledCard color="#00BEED" bg="#00576C">
                <h1>1st Line</h1>
                <p>Complete all numbers in the top row.</p>
                <img
                    draggable={false}
                    src="https://cdn.timepass.games/images/656a34bd-7875-4c7e-954d-8fc75adc73e4.png"
                />
            </StyledCard>

            <StyledCard color="#00C8B7" bg="#00544D">
                <h1>2nd Line</h1>
                <p>Complete all numbers in the middle row.</p>
                <img
                    draggable={false}
                    src="https://cdn.timepass.games/images/8b0c3e6e-c555-4c57-9005-0d06545bf625.png"
                />
            </StyledCard>

            <StyledCard color="#FF5353" bg="#9F1414">
                <h1>3rd Line</h1>
                <p>Complete all numbers in the bottom row.</p>
                <img
                    draggable={false}
                    src="https://cdn.timepass.games/images/037c323e-cb91-46ef-9100-8487a6a6de50.png"
                />
            </StyledCard>

            <StyledCard color="#FF7715" bg="#963C00">
                <h1>Full House</h1>
                <p>Mark all numbers on your ticket before anyone else.</p>
                <img
                    draggable={false}
                    src="https://cdn.timepass.games/images/4792785c-1f3d-4d72-850b-85997f49444f.png"
                />
            </StyledCard>
        </CardContainer>
    );
};

export default PrizeCards;
